import { useMemo } from "react"
import { GetDigitalEventLibraryDocument, type LibrarySortType } from "~/graphql/generated/graphql"
import { reportGaps } from "~/shared/lib/schemas"
import { logLibraryEdges } from "../cardTelemetry"
import { isDigitalEventEdge } from "../guards"
import { toDigitalEventCard } from "../projections"
import { useLibraryQuery } from "./useLibraryQuery"
import type { LibraryListResult } from "./useStudyLibrary"

export const useDigitalEventLibrary = (sortBy: LibrarySortType): LibraryListResult => {
  const query = useLibraryQuery("digital-event", GetDigitalEventLibraryDocument, sortBy)

  const items = useMemo(() => {
    const edges = (query.data?.pages ?? [])
      .flatMap(page => page.user?.libraryV2?.edges ?? [])
      .filter(isDigitalEventEdge)

    logLibraryEdges("events", edges)

    const cards = edges.map(edge => toDigitalEventCard(edge.node.asset))

    reportGaps("events", cards)

    return cards
  }, [query.data?.pages])

  return {
    items,
    isLoading: query.isLoading,
    isError: query.isError,
    hasNextPage: query.hasNextPage,
    isFetchingNextPage: query.isFetchingNextPage,
    fetchNextPage: query.fetchNextPage,
  }
}
